import styled, { css } from 'styled-components';
import { NavLink as RouterNavLink } from 'react-router-dom';

export const Aside = styled.aside`
  background: #f7f7f7;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

export const NavLink = styled(RouterNavLink)`
  padding: 16px 24px;
  margin-bottom: 16px;
  background: white;
  border-radius: 10px;
  color: #006633;

  &:hover {
    background: #f38725;
    color: white;
  }

  &.active {
    background: #f38725;
    color: white;
  }
`;

type StatusTone = 'success' | 'warning' | 'neutral' | 'info';
const STATUS_MAP: Record<StatusTone, { bg: string; color: string }> = {
  success: { bg: '#e6f3ec', color: '#006633' },
  warning: { bg: '#fff4e0', color: '#b45309' },
  info: { bg: '#e0ecff', color: '#1d4ed8' },
  neutral: { bg: '#f1f5f9', color: '#475569' },
};

export const StatusBadge = styled.span<{ $tone: StatusTone }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  ${({ $tone }) => css`
    background: ${STATUS_MAP[$tone].bg};
    color: ${STATUS_MAP[$tone].color};
  `}
`;

type PriorityTone = 'neutral' | 'info' | 'warning' | 'danger';
const PRIORITY_MAP: Record<PriorityTone, { bg: string; color: string }> = {
  neutral: { bg: '#f1f5f9', color: '#475569' },
  info: { bg: '#e0ecff', color: '#1d4ed8' },
  warning: { bg: '#fff4e0', color: '#b45309' },
  danger: { bg: '#fee2e2', color: '#b91c1c' },
};

export const PriorityBadge = styled.span<{ $tone: PriorityTone }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  ${({ $tone }) => css`
    background: ${PRIORITY_MAP[$tone].bg};
    color: ${PRIORITY_MAP[$tone].color};
  `}
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: #f8fafc;
    border-color: #006633;
    color: #006633;
  }
`;

export const QuickButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid ${({ $active }) => ($active ? '#006633' : '#e2e8f0')};
  background: ${({ $active }) => ($active ? '#006633' : '#ffffff')};
  color: ${({ $active }) => ($active ? '#ffffff' : '#334155')};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: #006633;
    ${({ $active }) =>
      !$active &&
      css`
        color: #006633;
      `}
  }
`;
